// MRS Studios — PDP: thumbnail swap, colour swatch, size select, accordion, add to bag / pre-order
(function () {
  'use strict';

  // --- Thumbnail gallery ---
  function initGallery() {
    var mainImg = document.getElementById('mrs-main-image');
    var thumbs = document.querySelectorAll('.mrs-thumb');
    if (!mainImg || !thumbs.length) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        mainImg.src = thumb.dataset.src;
        mainImg.srcset = thumb.dataset.srcset || '';
        thumbs.forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');
      });
    });
  }

  function findVariant(id) {
    var data = window.MRS_PRODUCT;
    if (!data || !id) return null;
    for (var i = 0; i < data.variants.length; i++) {
      if (String(data.variants[i].id) === String(id)) return data.variants[i];
    }
    return null;
  }

  // Price, button label and pre-order note for the variant currently in the form.
  // MRS_PRODUCT.meta (mrs-product-detail.liquid) holds the formatted prices and the pre-order flag.
  function updateBuyState() {
    var data = window.MRS_PRODUCT || {};
    var input = document.getElementById('mrs-variant-id');
    var priceEl = document.getElementById('mrs-price');
    var btn = document.getElementById('mrs-atb');
    var note = document.getElementById('mrs-preorder-note');
    var msg = document.getElementById('mrs-atb-msg');
    var v = findVariant(input && input.value);
    var m = v && data.meta ? data.meta[v.id] : null;

    if (priceEl && m) {
      priceEl.innerHTML = m.compare
        ? '<span class="mrs-pdp__price-compare">' + m.compare + '</span> ' +
          '<span class="mrs-pdp__price-sale">' + m.price + '</span> ' +
          '<span class="mrs-pdp__price-badge">Sale</span>'
        : m.price;
    }
    var preorder = !!(v && v.available && m && m.preorder);
    if (btn) {
      btn.disabled = !(v && v.available);
      btn.textContent = !v ? 'Unavailable' : !v.available ? 'Sold Out' : preorder ? 'Pre-order' : 'Add to Bag';
    }
    if (note) note.hidden = !preorder;
    if (msg) msg.textContent = '';
  }

  // --- Variant selector (type tiles + colour swatches + size tiles) ---
  function initVariants() {
    var data = window.MRS_PRODUCT;
    if (!data) return;

    var variants = data.variants;
    var options = data.options; // e.g. ['Type', 'Colour', 'Size']
    var meta = data.meta || {};
    var variantInput = document.getElementById('mrs-variant-id');
    var sizesEl = document.getElementById('mrs-sizes');

    // Find size option index
    var sizeIdx = -1;
    options.forEach(function (name, i) {
      if ((name || '').toLowerCase() === 'size') sizeIdx = i;
    });

    // Selection state: option index → currently selected value (excludes size)
    var selection = {};

    function getOpt(v, idx) { return v['option' + (idx + 1)]; }

    // Read active Liquid-rendered elements to initialise selection
    function initSelection() {
      document.querySelectorAll('.mrs-swatch.active[data-option-index]').forEach(function (el) {
        var idx = parseInt(el.getAttribute('data-option-index'), 10);
        if (!isNaN(idx)) selection[idx] = el.getAttribute('data-colour');
      });
      document.querySelectorAll('.mrs-type-tile.active[data-option-index]').forEach(function (el) {
        var idx = parseInt(el.getAttribute('data-option-index'), 10);
        if (!isNaN(idx)) selection[idx] = el.getAttribute('data-value');
      });
    }

    // Does variant match all non-size selections?
    function matchesSelection(v) {
      return options.every(function (name, i) {
        if (i === sizeIdx) return true;
        if (selection[i] === undefined) return true;
        return getOpt(v, i) === selection[i];
      });
    }

    function renderSizes() {
      // No size option — auto-select first matching variant
      if (sizeIdx < 0) {
        if (sizesEl) sizesEl.innerHTML = '';
        var match = variants.filter(matchesSelection);
        var avail = match.filter(function (v) { return v.available; });
        if (variantInput) variantInput.value = avail.length ? avail[0].id : (match.length ? match[0].id : '');
        updateBuyState();
        return;
      }
      if (!sizesEl) return;
      sizesEl.innerHTML = '';
      var pool = variants.filter(matchesSelection);
      // Deduplicate by size label
      var seen = {};
      pool.forEach(function (v) {
        var label = getOpt(v, sizeIdx);
        if (seen[label]) return;
        seen[label] = true;
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'mrs-size-tile' + (v.available ? '' : ' sold-out');
        btn.setAttribute('data-variant-id', v.id);
        btn.textContent = label;
        if (!v.available) btn.setAttribute('disabled', '');
        else if (meta[v.id] && meta[v.id].preorder) btn.title = 'Pre-order · ' + data.preorderNote;
        btn.addEventListener('click', function () {
          sizesEl.querySelectorAll('.mrs-size-tile').forEach(function (t) { t.classList.remove('active'); });
          btn.classList.add('active');
          if (variantInput) variantInput.value = v.id;
          updateBuyState();
        });
        sizesEl.appendChild(btn);
      });
      var firstAvail = sizesEl.querySelector('.mrs-size-tile:not(.sold-out)');
      if (firstAvail) {
        firstAvail.classList.add('active');
        if (variantInput) variantInput.value = firstAvail.getAttribute('data-variant-id');
      } else if (variantInput) {
        // Every size of this colour / type is sold out: point the form at it so the button reads
        // Sold Out, instead of keeping the previous selection's id (which added the wrong colour).
        variantInput.value = pool.length ? pool[0].id : '';
      }
      updateBuyState();
    }

    // Update main image to first variant matching current selection that has an image
    function updateMainImage() {
      var mainImg = document.getElementById('mrs-main-image');
      if (!mainImg) return;
      var match = variants.filter(function (v) {
        return matchesSelection(v) && v.featured_image && v.featured_image.src;
      });
      if (!match.length) return;
      var src = match[0].featured_image.src;
      mainImg.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=900';
      mainImg.srcset = '';
      var getBase = function (u) { return u ? u.split('?')[0].split('/').pop() : ''; };
      var varFile = getBase(src);
      document.querySelectorAll('.mrs-thumb').forEach(function (t) {
        t.classList.toggle('active', getBase(t.getAttribute('data-src')) === varFile);
      });
    }

    // Colour swatch handlers
    document.querySelectorAll('.mrs-swatch[data-option-index]').forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        var optIdx = parseInt(swatch.getAttribute('data-option-index'), 10);
        document.querySelectorAll('.mrs-swatch[data-option-index="' + optIdx + '"]').forEach(function (s) {
          s.classList.remove('active');
        });
        swatch.classList.add('active');
        selection[optIdx] = swatch.getAttribute('data-colour');
        var labelEl = swatch.closest('.mrs-pdp__option').querySelector('.mrs-colour-label');
        if (labelEl) labelEl.textContent = selection[optIdx];
        updateMainImage();
        renderSizes();
      });
    });

    // Type tile handlers
    document.querySelectorAll('.mrs-type-tile[data-option-index]').forEach(function (tile) {
      tile.addEventListener('click', function () {
        var optIdx = parseInt(tile.getAttribute('data-option-index'), 10);
        document.querySelectorAll('.mrs-type-tile[data-option-index="' + optIdx + '"]').forEach(function (t) {
          t.classList.remove('active');
        });
        tile.classList.add('active');
        selection[optIdx] = tile.getAttribute('data-value');
        updateMainImage(); // show the chosen piece (e.g. Vest) as colour swatches already do
        renderSizes();
      });
    });

    initSelection();
    renderSizes();
  }

  // --- Accordion ---
  function initAccordion() {
    var triggers = document.querySelectorAll('.mrs-accordion__trigger');
    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var panel = trigger.nextElementSibling;
        var isOpen = trigger.classList.contains('open');
        trigger.classList.toggle('open', !isOpen);
        panel.style.maxHeight = isOpen ? '0' : panel.scrollHeight + 'px';
        trigger.querySelector('.mrs-accordion__icon').textContent = isOpen ? '+' : '−';
      });
    });
  }

  // --- Add to bag / pre-order ---
  function initAddToBag() {
    var form = document.getElementById('mrs-add-to-bag');
    if (!form) return;
    var btn = document.getElementById('mrs-atb');
    var msg = document.getElementById('mrs-atb-msg');
    function say(text) { if (msg) msg.textContent = text; }
    function restore(label) { if (btn) { btn.disabled = false; btn.textContent = label; } }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var data = window.MRS_PRODUCT || {};
      var v = findVariant(document.getElementById('mrs-variant-id').value);
      // Inline messages, not alert(): a native dialog blocks the page.
      if (!v) { say('Please choose an available option.'); return; }
      if (!v.available) { say('This option is sold out.'); return; }
      if (!window.MrsCart) return;
      var m = data.meta ? data.meta[v.id] : null;
      // Line-item property: shown in the bag, at checkout, on the order confirmation and in the admin order.
      // ref: https://shopify.dev/docs/api/ajax/reference/cart#post-locale-cart-add-js (items[].properties)
      var props = m && m.preorder ? { 'Pre-order': data.preorderNote } : null;
      var label = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
      say('');
      var pending = window.MrsCart.add(v.id, 1, props);
      if (!pending || !pending.then) { restore(label); return; }
      pending.then(function () {
        restore(label);
      }, function (err) {
        restore(label);
        say(err && err.message ? err.message : 'Could not add to bag. Please try again.');
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initGallery();
    initVariants();
    initAccordion();
    initAddToBag();
  });
})();
